import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_CONTRACT_SUCCESS,
  CREATE_SUSPEND_DOCUMENT_SUCCESS,
  FETCH_CONTRACT_SUCCESS,
  GET_CONTRACT_LOCATIONS,
  GET_CONTRACT_SUCCESS,
  SAVE_CONTRACT_QUERY,
  SET_CONTRACT_UPLOAD,
  UPLOAD_CONTRACT_DOCUMENT_SUCCESS
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchRelationshipSearchSuccess, fetchStart, fetchSuccess} from "./Common";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";

export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_CONTRACT_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_CONTRACT_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_CONTRACT_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_CONTRACT_SUCCESS,
    data
  };
};

export const getAll = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {contract} = store.getState();
      const {query} = contract;
      const response = await axios.get(`/contract?limit=0&offset=0&filters=[]`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {contract} = store.getState();
      const {query} = contract;
      const response = await axios.get(`/contract?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {contract} = store.getState();
      const {query} = contract;
      const response = await axios.get(`/contract/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const processedData = await processDataForDownload(response.data);
      const str = arrayToCSV(processedData, filters, columns);
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

// process download data
function processDataForDownload(data) {
  return new Promise((resolve, _) => {
    resolve(data.map(item => {
      if(item.vendor) {
        item['vendor'] = item.vendor && item.vendor.name || ""
      }
      if(item.prevContract) {
        item['prevContract'] = item.prevContract && item.prevContract.id || ""
      }
      if(item.nextContract) {
        item['nextContract'] = item.nextContract && item.nextContract.id || ""
      }
      return item;
    }));
  });
}

export const createResource = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      // console.log(payload);
      let formData = new FormData();

      const documentData = [];
      payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = {...item};
        delete data.file;
        documentData.push(data)
      });

      formData.append('documentData', JSON.stringify(documentData));
      formData.append('assets', JSON.stringify(payload.assets));
      //formData.append('leaseAmount', JSON.stringify(payload.leaseAmount));


      Object.keys(payload).forEach(key => {
        if(key === 'documents' || key === 'assets') {
          return
        }
        if(!payload[key]) {
          return
        }

        formData.append(key, payload[key]);
      });


      const response = await axios.post(`/contract`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});

      //const response = await axios.post(`/contract`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      dispatch(getResource());
      message.success('Contract added');
      history.push('/contract');
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.put(`/contract/${id}`, payload);
      dispatch(fetchSuccess());
      history.push('/contract');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/contract/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/contract/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const archivedResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      // console.log(`Archived `, id);
      await axios.get(`/contract/archive/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchLeasableAssetData = (searchValue, model, field) => {
  return async (dispatch) => {

    if(field === 'name') {
      let searchOriginalString = searchValue;
      searchOriginalString = searchOriginalString.replace(/[^a-zA-Z0-9 ]/g, '');
      searchValue = searchOriginalString;
    }

    dispatch(fetchStart());
    try {
      if(field === 'presentStatus') {
        field = 'changeStatus';
      }
      const response = await axios.get(`/common/search?searchValue=${searchValue}&model=${model}&field=${field}&leasable=true`);
      dispatch(fetchSuccess());
      dispatch(fetchRelationshipSearchSuccess(response.data.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const updateAssetPeriod = (contractId, assetRecordId, updateType, assetLease) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {

      const response = await axios.post(`/contract/assets/${contractId}/${assetRecordId}/${updateType}`, assetLease);
      if(response.data) {
        message.success("Updated")
        history.push('/contract/view/' + contractId);
      }
      dispatch(fetchSuccess());
      dispatch(fetchResource(contractId));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const updateSuspendedRecord = (contractId, assetRecordId, updateType, suspendedObject) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {

      const response = await axios.post(`/contract/suspend/${contractId}/${assetRecordId}/${updateType}`, suspendedObject);
      if(response.data) {
        message.success("Updated")
        history.push('/contract/view/' + contractId);
      }
      dispatch(fetchSuccess());
      dispatch(fetchResource(contractId));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createDocument = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());
    try {
      const docs = await axios.get(`/document-type`);
      if(!docs || !docs.data || !docs.data.data || docs.data.data.length === 0) {
        throw new Error('Document type is invalid!');
      }
      const docType = docs.data.data[0];
      const newPayload = {
        type: docType._id,
        name: 'Suspend-info-documents',
        ...payload
      };

      let formData = new FormData();
      await Object.keys(newPayload).forEach(key => {
        formData.append(key, newPayload[key]);
      });
      const response = await axios.post(`/document`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      dispatch(fetchSuccess());
      dispatch(createDocumentSuccess({data: response.data}));
    } catch (error) {
      message.error(error.message)
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const createDocumentSuccess = ({data}) => {
  return {
    type: CREATE_SUSPEND_DOCUMENT_SUCCESS,
    data
  };
};

export const getLocations = () => {
  return async (dispatch) => {

    dispatch(fetchStart());
    try {
      const response = await axios.get(`/location`);
      dispatch(fetchSuccess());
      dispatch(getLocationSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getLocationSuccess = ({data}) => {
  return {
    type: GET_CONTRACT_LOCATIONS,
    data
  };
};

export const createResourceWithExcel = (files, payload) => {

  return async (dispatch) => {
    dispatch(fetchStart());
    dispatch(setContractUploading(true));
    try {
      let formData = new FormData();

      const documentData = [];
      payload.documents && payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = {...item};
        delete data.file;//
        documentData.push(data)
      });

      formData.append('documentData', JSON.stringify(documentData));

      files.map((item) => {
        formData.append('files', item);
      });

      Object.keys(payload).forEach(key => {
        formData.append(key, payload[key]);
      });
      const response = await axios.post(`/contract`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});

      //const response = await axios.post(`/contract`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      dispatch(getResource());
      dispatch(setContractUploading(false));
      message.success('Contract added');
      history.push('/contract');
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error));
      dispatch(setContractUploading(false));
      // const msg = (error.response.data.message || '').split('\n').map((item, i) => <p key={i}>{item}</p>);
      message.error(error.response.data.message);
    }
  }
};

export const setContractUploading = (data) => {
  return {
    type: SET_CONTRACT_UPLOAD,
    data
  };
};

export const updateContractField = (contract, assetRecord, data) => {

  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/contract/field-edit/${contract}/${assetRecord || ''}`, data);
      if(response.data) {
        message.success("Updated");
        history.push('/contract/view/' + contract);
      }
      dispatch(fetchSuccess());
      dispatch(fetchResource(contract));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
}

export const removeContractDocument = (contract, doc) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/contract/remove-doc/${contract}/${doc}`);
      if(response.data) {
        message.success("Success");
      }
      dispatch(fetchSuccess());
      dispatch(fetchResource(contract));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
}

export const uploadImage = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let formData = new FormData();
      formData.append('data', JSON.stringify(payload.file));
      // formData.append('files', data.file);
      formData.append("file", payload.file.file);
      // formData.append("contractId", payload.contractId);
      const response = await axios.put(`/contract/upload/${payload.contractId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
      dispatch(fetchSuccess());
      if(response.data) {
        dispatch(fetchResource(payload.contractId));
        dispatch(uploadImageSuccess({data: response.data}));
        message.success('Uploaded!');
      } else
        message.error('Not Uploaded!');
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const uploadImageSuccess = ({data}) => {
  return {
    type: UPLOAD_CONTRACT_DOCUMENT_SUCCESS,
    data,
  }
};
